import { render, staticRenderFns } from "./BusinessLicenseVerify.vue?vue&type=template&id=d2d79d20&scoped=true"
import script from "./BusinessLicenseVerify.vue?vue&type=script&lang=js"
export * from "./BusinessLicenseVerify.vue?vue&type=script&lang=js"
import style0 from "./BusinessLicenseVerify.vue?vue&type=style&index=0&id=d2d79d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d79d20",
  null
  
)

export default component.exports